<template>
  <div class="emails">
    <NavBar :admin="true" :items="items" />
    <v-main>
      <v-container>
        <p class="text-h5 mt-2" v-translate>Emails</p>
        <v-btn small fab class="mb-3" color="primary" @click="showNewEmailForm = !showNewEmailForm">
					<v-icon>mdi-plus</v-icon>
				</v-btn>
        <v-dialog v-model="showNewEmailForm" max-width="70%" scrollable>
          <v-card>
            <v-card-title class="title primary--text mb-2 secondary">
              Criar Email
            </v-card-title>
            <v-card-text class="pt-2">
              <EmailForm ref="emailForm" :email="newEmail" />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary darken-1" text @click="showNewEmailForm = false">
                <translate key="close">Close</translate>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" text @click="createEmail" :loading="loadingCreateEmail">
                <translate key="save">Save</translate>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showSendEmail" max-width="100%" scrollable :persistent="loadingSendEmail">
          <v-card>
            <v-card-title v-if="openEmail" class="title primary--text mb-2 secondary">
              Enviar Email - {{openEmail.description}}
            </v-card-title>
            <v-card-text class="pt-2">
              <Spaces ref="spaces" :selectable="true" />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <span v-if="sendEmailError" class="red--text">Erro</span>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" text @click="confirmSendEmail" :loading="loadingSendEmail">
                Enviar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showConfirmSendEmail" max-width="30%" scrollable persistent>
          <v-card>
            <v-card-title v-if="openEmail" class="title primary--text mb-2 secondary">
              Confirmar envio de Email - {{openEmail.description}}
            </v-card-title>
            <v-card-text>
              <p v-for="email in selectedEmails" :key="email.email">{{email.email}}</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary darken-1" text @click="showConfirmSendEmail = false">
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" text @click="showConfirmSendEmail = false; sendEmail()">
                Enviar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
        <template v-else>
          <p v-if="emails.length == 0" class="font-weight-thin ml-2" v-translate key="no-payments">No emails.</p>
          <Email v-else v-for="email in emails" :key="email.id" @edit-email="editEmail" @delete-email="deleteEmail" @open-send-email="openSendEmail" :email="email" />
        </template>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Email from "@/components/admin/Email.vue";
import EmailForm from "@/components/admin/EmailForm"
import Spaces from "@/views/admin/Spaces"
import axios from "axios";

export default {
  name: "Emails",
  components: {
    NavBar,
    Email,
    EmailForm,
    Spaces
  },
  data: () => ({
    loading: false,
    loadingCreateEmail: false,
    showNewEmailForm: false,
    newEmail: {
      automatic: false,
      description: "",
      subject_pt: "",
      subject_en: "",
      subject_es: "",
      body_pt: "",
      body_en: "",
      body_es: ""
    },
    showSendEmail: false,
    showConfirmSendEmail: false,
    loadingSendEmail: false,
		sendEmailError: false,
    selectedEmails: [],
    openEmail: null,
    emails: []
  }),
  computed: {
    items() {
      return [
        {
          text: this.$gettext("Dashboard"),
          disabled: false,
          link: true,
          to: {name: 'dashboard'}
        },
        {
          text: this.$gettext("Emails"),
          disabled: true,
          link: true
        }
      ];
    },
  },
  methods: {
    createEmail() {
      let form = this.$refs.emailForm.getForm();
			if(form) {
        this.loadingCreateEmail = true;
				axios
					.post("/admin/emails/new", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
              this.emails.push(response.data.email);
							this.showNewEmailForm = false;
						}
            this.loadingCreateEmail = false;
					})
					.catch(error => {
            console.log(error);
            this.loadingCreateEmail = false;
          });
			}
    },
    editEmail(email) {
      let m = this.emails.find(e => e.id === email.id);
      Object.assign(m, email);
    },
    deleteEmail(email) {
      this.emails.splice(this.emails.indexOf(email), 1);
    },
    openSendEmail(email) {
      this.showSendEmail = true;
      this.openEmail = email;
    },
    confirmSendEmail() {
      this.selectedEmails = this.$refs.spaces.getSelectedEmails();
      console.log(this.selectedEmails);
      if(this.selectedEmails.length == 0) return 0;
      this.showConfirmSendEmail = true;
    },
    sendEmail() {
			this.sendEmailError = false;
			this.loadingSendEmail = true;
			axios
				.post("/admin/emails/" + this.openEmail.id + "/send", this.selectedEmails)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "ok") {
						this.showSendEmail = false;
					} else {
						this.sendEmailError = true;
					}
					this.loadingSendEmail = false;
				})
				.catch(error => {
					console.log(error);
					this.loadingSendEmail = false;
					this.sendEmailError = true;
				});
		},
  },
  created() {
    this.loading = true;
    axios
			.get("/admin/emails")
			.then(response => {
        console.log(response.data);
        this.emails = response.data.emails;
				this.loading = false;
			})
			.catch(error => {
        console.log(error);
        this.loading = false;
      });
  }
}
</script>